// Hand-drawn faded wellness illustrations, hand-placed into hero/section white space.
export function LeafBranch({ className = "", style }) {
  return (
    <svg viewBox="0 0 120 160" fill="none" stroke="currentColor" strokeWidth="1.6"
      strokeLinecap="round" strokeLinejoin="round" className={className} style={style} aria-hidden="true">
      <path d="M60 158 C60 120 60 60 60 8" />
      <path d="M60 40 C40 30 28 34 20 22 C36 20 50 24 60 40Z" />
      <path d="M60 62 C80 52 92 56 100 44 C84 42 70 46 60 62Z" />
      <path d="M60 86 C40 76 28 80 20 68 C36 66 50 70 60 86Z" />
      <path d="M60 110 C80 100 92 104 100 92 C84 90 70 94 60 110Z" />
      <path d="M60 20 C52 12 46 12 42 6 C52 6 58 10 60 20Z" />
    </svg>
  );
}

export function CitrusSprig({ className = "", style }) {
  return (
    <svg viewBox="0 0 140 120" fill="none" stroke="currentColor" strokeWidth="1.6"
      strokeLinecap="round" strokeLinejoin="round" className={className} style={style} aria-hidden="true">
      <circle cx="52" cy="70" r="40" />
      <circle cx="52" cy="70" r="30" />
      <path d="M52 40 L52 100 M22 70 L82 70 M31 49 L73 91 M73 49 L31 91" />
      <path d="M92 34 C104 20 118 18 130 24 C120 34 106 38 92 46" />
      <path d="M100 40 C100 30 106 24 118 22" />
    </svg>
  );
}

export function HerbSprig({ className = "", style }) {
  return (
    <svg viewBox="0 0 120 150" fill="none" stroke="currentColor" strokeWidth="1.6"
      strokeLinecap="round" strokeLinejoin="round" className={className} style={style} aria-hidden="true">
      <path d="M60 150 C58 110 56 70 66 12" />
      <path d="M64 30 C82 20 96 26 104 14 C88 8 74 14 64 30Z" />
      <path d="M60 56 C42 46 28 52 20 40 C36 34 50 40 60 56Z" />
      <path d="M62 82 C80 72 94 78 102 66 C86 60 72 66 62 82Z" />
      <path d="M58 108 C40 98 26 104 18 92 C34 86 48 92 58 108Z" />
    </svg>
  );
}
